import React from 'react';
import PropTypes from 'prop-types';
import ChunkedUploadFolder from '../Shared/ChunkedUploadFolder';
import './NewProductionUploadFolder.css';

const NEW_PRODUCTION_ROOT =
  process.env.REACT_APP_NEW_PRODUCTION_START_PATH || '/new-production';

function NewProductionUploadFolder({
  currentPath,
  userId,
  onFolderUploaded,
}) {
  return (
    <ChunkedUploadFolder
      currentPath={currentPath}
      userId={userId}
      onFolderUploaded={onFolderUploaded}
      rootPath={NEW_PRODUCTION_ROOT}
      sessionPrefix="new_production_folder"
    />
  );
}

NewProductionUploadFolder.propTypes = {
  currentPath: PropTypes.string,
  userId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onFolderUploaded: PropTypes.func,
};

export default NewProductionUploadFolder;
